'use strict';

var $                   = require('jquery');
var Core                = require('../core/core.js');
var ModalButton         = require('./modal__button.js');
var ModalButtonRow      = require('./modal__button__row.js');
var ModalCheckBox       = require('./modal__check__box.js');
var ModalSelectBox      = require('./modal__select__box.js');

/**
 * Creates a Tab
 *
 * @class
 */

class Modal extends Core {

    _defaults() {
        return {
            target: '.js-modal',
            fields: {
                'title': '',
                'body': '',
                'modal': false,
                'closeOnClick': false,
                'footer': ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__modal'>
                <div class='editor__modal__top'>
                    <div class='editor__modal__top__title'><%- title %></div>
                    <div class='editor__modal__top__close'>
                        <div class='editor__modal__top__close__x js-editor__modal__top__close__x'><%= embedded_svg('icon-cancel') %></div>
                    </div>
                </div>
                <div class='editor__modal__body'>
                    ` + options.fields["body"] + `
                </div>
                <div class='editor__modal__body__buttons'></div>

                <% if (footer) { %>
                    <div class='editor__modal__footer'>
                    <%- footer %>
                    </div>
                <% } %>
            </div>
        `;

        super.render();

        /**
         * Click event
         *
         * @fires Modal#_clicked
         */
        $('.js-editor__modal__top__close__x', this.$el).on('click', this._closeClicked.bind(this));

        if(options.fields["modal"]) {
            this.$overlay = $("<div class='editor__modal__bg-overlay'></div>").appendTo(this.$el.parent());
            if(options.fields["closeOnClick"]) $('.editor__modal__bg-overlay', this.$el.parent()).on('click', this._closeClicked.bind(this));
        }
    }

    /**
     * @event Modal#Cioui:Modal:clicked
     * @property {String}Cioui:Modal:clicked
     * @returns {Object} event - native click Event
     */

    _closeClicked(e){
        e.preventDefault();
        this.$el.trigger('Cioui:Modal:close:clicked', e);
    }

    /**
     * set theme of modal
     *
     * @param {String} label
     */
    setTheme(theme){
        if(theme == "error"){
            this.$el.addClass('editor__modal--error');
        }
        else if(theme == "dark"){
            this.$el.addClass('editor__modal--dark');
        }
    }

    /**
     * set theme of modal
     *
     * @param {String} label
     */
    addButton(title, style){
        return new ModalButton({
            target: $(".editor__modal__body__buttons", this.$el),
            fields: {
                'title': title,
                'style': style
            }
        });
    }

    deleteButtonArea(){
        $(".editor__modal__body__buttons", this.$el).remove();
    }

    addButtonRow(text, style, subtext){
        return new ModalButtonRow({
            target: $(".editor__modal__body", this.$el),
            fields: {
                'text': text,
                'subtext': subtext
            }
        });
    }

    addCheckBox(title, checked){
        return new ModalCheckBox({
            target: $(".editor__modal__body", this.$el),
            fields: {
                'title': title,
                'checked': checked
            }
        });
    }

    addSelectBox(title, options){
        return new ModalSelectBox({
            target: $(".editor__modal__body", this.$el),
            fields: {
                'title': title,
                'options': options
            }
        });
    }

    /**
     * remove modal
     *
     */
    remove() {
        if(this.$overlay) this.$overlay.remove();
        this.$el.remove();
    }

}
module.exports = Modal;